import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography, fontWeights } from '../../../../../styles/typography';

export const locationsDisclaimer = css(typography.effra16, {
  color: colorsPalette.grey60,
  display: 'inline-block',
  marginRight: 8,
});

export const locationDisclaimerIcon = css({
  background: colorsPalette.brown20,
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'none',
  verticalAlign: 'middle',
  [MediaQueries.mdAndUp]: {
    display: 'inline',
  },
});

export const tooltip = css(typography.effra16, {
  '> div': {
    boxShadow: shadows.shadow40,
    minWidth: 335,
    zIndex: 2,
    '> div': {
      padding: '16px 24px',
      color: colorsPalette.grey80,
    },
  },
});

export const locations = css(typography.effra18, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  marginRight: 8,
});

export const buttonWrap = showMap =>
  css({
    background: colorsPalette.white,
    bottom: showMap ? 16 : 0,
    boxShadow: shadows.shadow40,
    display: 'flex',
    justifyContent: 'flex-end',
    left: 0,
    margin: '0 auto',
    position: 'fixed',
    right: 0,
    width: showMap ? 140 : '100%',
    zIndex: 2,

    [MediaQueries.sm]: {
      height: showMap ? 56 : 90,
    },

    [MediaQueries.mdAndUp]: {
      boxShadow: 'none',
      margin: 0,
      position: 'static',
      width: 'auto',
    },
  });

export const button = css(typography.effra16, {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: 0,
  textTransform: 'none',

  [MediaQueries.mdAndUp]: {
    justifyContent: 'flex-end',
  },
});

export const mapIcon = css({
  marginLeft: 9,
});

export const buttonText = css({
  display: 'inline-block',
});
